import React from "react";
import { Minus, Plus, X } from "lucide-react";

/**
 * One row in the cart drawer. Renders the product image, name, variant,
 * qty controls and line total. Calls `onUpdateQty(key, delta)` and
 * `onRemove(key)` on the parent so the parent owns cart state.
 */
export const CartItem = ({ item, onUpdateQty, onRemove }) => (
  <li className="py-5 flex gap-4" data-testid={`cart-item-${item.product_id}`}>
    <img
      src={item.image}
      alt={item.name}
      className="w-20 h-24 object-cover bg-[#efe6db]"
      loading="lazy"
    />
    <div className="flex-1">
      <div className="flex justify-between items-start">
        <div>
          <div className="font-serif text-lg leading-tight">{item.name}</div>
          <div className="text-xs text-[#1a1814]/60 mt-1">
            {item.color} · {item.size}
          </div>
        </div>
        <button
          type="button"
          onClick={() => onRemove(item.key)}
          className="text-[#1a1814]/40 hover:text-[#1a1814]"
          data-testid={`cart-remove-${item.product_id}`}
          aria-label="Remove"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <div className="flex items-center justify-between mt-4">
        <div className="flex items-center border border-[#1a1814]/20">
          <button
            type="button"
            onClick={() => onUpdateQty(item.key, -1)}
            className="w-8 h-8 grid place-items-center hover:bg-[#1a1814]/5"
            aria-label="Decrease"
          >
            <Minus className="w-3 h-3" />
          </button>
          <span className="w-8 text-center text-sm">{item.quantity}</span>
          <button
            type="button"
            onClick={() => onUpdateQty(item.key, 1)}
            className="w-8 h-8 grid place-items-center hover:bg-[#1a1814]/5"
            aria-label="Increase"
          >
            <Plus className="w-3 h-3" />
          </button>
        </div>
        <div className="font-serif text-base">£{(item.price * item.quantity).toFixed(2)}</div>
      </div>
    </div>
  </li>
);
